module.exports = __webpack_public_path__ + "img/gepres-blogs.eaa2bc04.svg";